import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import { getShiftByDay } from 'actions/ReportsAction';
import { clearFormInput } from 'actions/FormActions';
import Body from './Body';
import Header from './Header';
import Button from 'screens/components/basic/Button';
import WithRouter from 'custom/withRouter';

class ShiftByDay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 25,
            totalRow: 0,
            model: {
                pageNumber: 0,
                pageSize: 0,
                beginDate: '',
                endDate: '',
                branchId: 0,
                emmployeeId: 0
            }
        };

    }
    componentWillMount() {
        this.filter();
        this.cleanSearch();
    }

    resetPagination = (page) => {
        this.setState({ activePage: page ? page : 1 });
    }

    changePage = (e) => {
        this.resetPagination(e);
    }

    getReport = () => {
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let beginDate = this.props.shiftByDayBeginDate ? moment(this.props.shiftByDayBeginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.shiftByDayEndDate ? moment(this.props.shiftByDayEndDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchId = this.props.shiftByDayBranchOption || this.props.loggedBranch;
        let employeeId = this.props.shiftByDayNumber;
        this.props.getShiftByDay({ pageNumber, pageSize, beginDate, endDate, branchId, employeeId });
    }


    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    cleanSearch = () => {
        this.props.clearFormInput(`ShiftByDayBeginDate`);
        this.props.clearFormInput(`ShiftByDayEndDate`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    render() {
        // const totalRow = this.props.shiftByDay.length > 0 ? this.props.shiftByDay[0].totalRow : 0;
        const header = (
            <div className="page_header">
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li><Link to="/report">{LOOKUP.report.text}</Link></li>
                    <li className="active">{LOOKUP.report.shiftByDay.text}</li>
                </ol>
                <h2>
                    {LOOKUP.report.shiftByDay.text}
                    <Button type="HeaderBackPage" onTouchTap={() => this.redirectToReport()} />
                </h2>
            </div>
        );
        return (
            <ContainerDivided headerContent={header}>
                <CardSimple>
                    <Header filter={this.filter} />
                    <hr />
                    <Body shiftByDay={this.props.shiftByDay} />
                </CardSimple>
            </ContainerDivided>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        loggedBranch: state.common.branchId,
        shiftByDay: state.reports.shiftByDay,
        shiftByDayBeginDate: state.form.ShiftByDayBeginDate,
        shiftByDayEndDate: state.form.ShiftByDayEndDate,
        shiftByDayNumber: state.form.ShiftByDayNumber,
        shiftByDayBranchOption: state.form.ShiftByDayBranchOption
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getShiftByDay: model => dispatch(getShiftByDay(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ShiftByDay));